// import { Form, Formik } from 'formik';
// import { useState } from 'react';
// import { toast } from 'react-toastify';
// import styled from 'styled-components';
// import * as yup from 'yup';

// import paymentApi from '../../../APIs/payment';
// import { useRoot } from '../../../context/RootProvider';
// import { Button, Input, Modal, Typography } from '../../../designComponents';
// import { requestAPI } from '../../../utils';

// const CardDetails = styled.div`
//   background-color: #fafafa;
//   padding: 15px 20px;
//   border: 1px solid #f0f0f0;
//   border-radius: 4px;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: space-between;
//   margin: 20px 0;
//   > .ant-typography {
//     margin-bottom: 0;
//   }
// `;

// const validation = yup.object().shape({
//   city: yup.string().required('Please enter city'),
//   state: yup.string().required('Please enter state'),
//   postalCode: yup.string().required('Plese enter postal code'),
//   addressLine: yup.string().required('Please enter address line'),
//   name: yup.string().required('Please enter name'),
//   email: yup.string().required('Please enter email'),
//   bankName: yup.string().required('Please enter bank name'),
//   accountNumber: yup.string().required('Please enter Account Number'),
// });

// type BankAccountType = {
//   accountNumber: string;
//   addressLine: string;
//   bankName: string;
//   city: string;
//   email: string;
//   name: string;
//   postalCode: string;
//   state: string;
// };

// const AddBankAccount = () => {
//   const [loading, setLoading] = useState(false);
//   const { auth } = useRoot();
//   const [initialValues, _setInitialValues] = useState({
//     accountNumber: '',
//     addressLine: '',
//     bankName: '',
//     city: '',
//     email: auth?.emailAddress || '',
//     name: auth?.fullName || '',
//     postalCode: '',
//     state: '',
//   });

//   const [visible, setVisible] = useState(false);

//   const handleSubmitForm = async () => {
//     try {
//       setLoading(true);
//       await requestAPI(paymentApi.addBankAcc());
//       toast.success('Account added successfully');
//       setLoading(false);
//     } catch (error) {
//       console.error(error);
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ maxWidth: '450px' }}>
//       <Modal
//         title="Are you sure you want to delete?"
//         open={visible}
//         onClose={() => setVisible(false)}
//       >
//         <div>
//           <Button variant="gray" onClick={() => setVisible(false)}>
//             Cancel
//           </Button>
//           <Button>Delete</Button>
//         </div>
//       </Modal>
//       <Typography>Bank Account</Typography>

//       <div>
//         <CardDetails>
//           <Typography color="#949494">XXXX-XXXX-XXXX-XXXX</Typography>
//         </CardDetails>
//       </div>

//       <Formik
//         initialValues={initialValues}
//         onSubmit={handleSubmitForm}
//         validationSchema={validation}
//         enableReinitialize
//       >
//         {({ values, setFieldValue, handleSubmit }) => {
//           return (
//             <Form onSubmit={handleSubmit}>
//               <div
//                 style={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   gap: '12px',
//                 }}
//               >
//                 <div>
//                   <Typography>Name</Typography>
//                   <Input
//                     name="name"
//                     value={values.name}
//                     onChange={(e) => setFieldValue('name', e.target.value)}
//                   />
//                 </div>

//                 <div>
//                   <Typography>Postal Code</Typography>
//                   <Input
//                     name="postalCode"
//                     value={values.postalCode}
//                     onChange={(e) =>
//                       setFieldValue('postalCode', e.target.value)
//                     }
//                   />
//                 </div>
//                 <div>
//                   <Typography>Address Line</Typography>
//                   <Input
//                     name="addressLine"
//                     value={values.addressLine}
//                     onChange={(e) =>
//                       setFieldValue('addressLine', e.target.value)
//                     }
//                   />
//                 </div>
//                 <div>
//                   <Typography>Bank Name</Typography>
//                   <Input
//                     name="bankName"
//                     value={values.bankName}
//                     onChange={(e) => setFieldValue('bankName', e.target.value)}
//                   />
//                 </div>
//                 <div>
//                   <Typography>IBAN</Typography>
//                   <Input
//                     name="accountNumber"
//                     value={values.accountNumber}
//                     onChange={(e) =>
//                       setFieldValue('accountNumber', e.target.value)
//                     }
//                   />
//                 </div>
//               </div>
//               <div
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   marginTop: '10px',
//                 }}
//               >
//                 <Button htmlType="submit" isLoading={loading}>
//                   ADD
//                 </Button>
//               </div>
//             </Form>
//           );
//         }}
//       </Formik>
//     </div>
//   );
// };

// export default AddBankAccount;
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import paymentApi from '../../../APIs/payment';
import { Button, Typography } from '../../../designComponents';
import { requestAPI } from '../../../utils';
interface BankAccount {
  id: string;
  bank_name: string;
  last4: string;
  country: string;
  currency: string;
  status: string;
  isDefault: boolean;
}
const ListBanks = () => {
  const [banks, setBanks] = useState<BankAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        setLoading(true);
        const response = await requestAPI(paymentApi.getBankAccounts()); // call your backend route
        setBanks(response.accounts);
      } catch (err: any) {
        console.error(err);
        setError(
          err?.response?.data?.message || 'Failed to fetch bank accounts'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchBanks();
  }, []);

  if (loading) return <Typography>Loading bank accounts...</Typography>;
  if (error) return <Typography color="red">{error}</Typography>;
  if (banks.length === 0)
    return <Typography>No bank accounts found</Typography>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginBottom: '30px',
      }}
    >
      <Typography variant="title">Your Bank Accounts</Typography>
      {banks.map((bank) => (
        <div
          key={bank.id}
          style={{
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            padding: '16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#fff',
            maxWidth: '400px',
          }}
        >
          <div>
            <Typography>
              {bank.bank_name} •••• {bank.last4}
            </Typography>
            <Typography color="#6b7280">
              {bank.currency?.toUpperCase()} | {bank.country}
            </Typography>
            <Typography color="#9ca3af">
              Status: {bank.status} {bank.isDefault ? '(Default)' : ''}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};
const AddBankAccount = () => {
  const [loading, setLoading] = useState(false);

  const handleAddBankAccount = async () => {
    try {
      setLoading(true);

      const response = await requestAPI(paymentApi.addBankAcc());

      const { url } = response;

      if (!url) {
        throw new Error('No redirect URL returned');
      }
      window.location.href = url;
    } catch (error) {
      console.error(error);
      toast.error('Failed to start bank account setup');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px' }}>
      <ListBanks></ListBanks>
      <Typography variant="title" style={{ marginBottom: '16px' }}>
        Bank Account
      </Typography>

      <Button onClick={handleAddBankAccount} isLoading={loading}>
        Add Bank Account
      </Button>
    </div>
  );
};

export default AddBankAccount;
